import Icons from './Icons';
import AsyncIcon from './AsyncIcon';

export { AsyncIcon };
export default Icons;
